if (!customElements.get('list-toggle')) {
  customElements.define(
    'list-toggle',
    // eslint-disable-next-line no-undef
    class ListToggle extends window.BAO.CustomElement() {
      constructor () {
        super()

        super.setupListeners()
      }

      setupListeners () {
        this.chooseListView = this.chooseListView.bind(this)
        if (this.els?.listView.exists) {
          this.els.listView.elements.forEach(listViewEl => {
            this.listeners.add(listViewEl, 'click', this.chooseListView)
          })
        }

        this.chooseGridView = this.chooseGridView.bind(this)
        if (this.els?.gridView.exists) {
          this.els.gridView.elements.forEach(gridViewEl => {
            this.listeners.add(gridViewEl, 'click', this.chooseGridView)
          })
        }
      }

      chooseListView (e) {
        e.preventDefault()
        document.body.classList.add(`lyt-Site-collectionListView`)
      }

      chooseGridView (e) {
        e.preventDefault()
        document.body.classList.remove(`lyt-Site-collectionListView`)
      }
    },
  )
}
